import { Flex } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import styles from './coupons.css'
import { CreateCoupon } from './CreateCoupon/CreateCoupon'
import { LinkedCoupons } from './LinkedCoupons'

interface Props {
  state: FormState
}

export function Coupons(props: Props) {
  const { state } = props

  const utmSource: string[] = useWatch({ form: state, name: 'utmSource' })

  const utmCampaign: string[] = useWatch({ form: state, name: 'utmCampaign' })

  return (
    <Flex className={styles.couponsSection}>
      <CreateCoupon utmSource={utmSource} utmCampaign={utmCampaign} />
      <LinkedCoupons utmSource={utmSource} utmCampaign={utmCampaign} />
    </Flex>
  )
}
